export default {
    area: "栾川城关镇",
    objectName: "",
    //url
    // hostUrl : 'http://cuiyun.dexian.ren/',
    apiHttpsUrl : 'https://lczhsq.anluoyun.cn/prod-api',
    apiRequestUrl : 'https://lczhsq.anluoyun.cn/api',
    apiUploadUrl: 'https://lczhsq.anluoyun.cn/api/UploadFile/UploadImgs',
    apiUploadFiles:'https://lczhsq.anluoyun.cn/api/UploadFile/UploadFiles',
    apiUploadvideo:'https://lczhsq.anluoyun.cn/api/UploadFile/UploadQiniuVideo',
}